<ng-container *ngIf="sucesso; else formObraDescartada">
  <app-sucesso
    [mensagem]="'Obrigado por nos informar!'"
    [botaoTexto]="'Continuar'"
    (continuar)="continuar()"
  ></app-sucesso>
</ng-container>
<ng-template #formObraDescartada>
  <div class="obra-descartada-container">
    <div class="form-content">
     
      <textarea
        id="taskDescription"
        class="form-control"
        [(ngModel)]="taskDescription"
        placeholder="Nos diga qual foi o problema e como podemos reproduzir."
      ></textarea>

  
    </div>

    <div class="footer-actions">
    
      <button class="btn btn-primary" type="button" (click)="reportarErro()">
        ENVIAR
      </button>
    </div>
  </div>
</ng-template>
